export const makeScrollBar = (sizePx: number) => ({
  '&::-webkit-scrollbar': {
    width: `${sizePx}px`,
    height: `${sizePx}px`,
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#DFF2F5',
    '&:hover': {
      backgroundColor: '#BFE5EB',
    },
  },
});
